import { FC } from "react";
import { observer } from "mobx-react";
import { Badge, Box, IconButton, Tooltip } from "@mui/material";
import { PiSlidersHorizontalLight } from "react-icons/pi";

import { useChatStore } from "../../../../hooks/useChatStore";
import {
  getActiveSidebarFilterCount,
  getActiveSidebarFilterSummaryLines,
} from "../../../helpers/sidebarFilterHelper";

export const SidebarFilterAction: FC = observer(() => {
  const chatStore = useChatStore();
  const { isSidebarFilterModeEnabled, sidebarFilters } = chatStore;
  const activeFilterCount = getActiveSidebarFilterCount(sidebarFilters);
  const summaryLines = getActiveSidebarFilterSummaryLines(sidebarFilters);

  const tooltipTitle =
    summaryLines.length > 0 ? (
      <Box>
        {summaryLines.map((line) => (
          <Box key={line}>{line}</Box>
        ))}
      </Box>
    ) : (
      "Filter chats"
    );

  return (
    <Box sx={{ pr: 2 }}>
      <Tooltip title={tooltipTitle} placement="bottom" arrow>
        <Badge
          color="error"
          badgeContent={activeFilterCount}
          invisible={activeFilterCount === 0}
          overlap="rectangular"
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{
            "& .MuiBadge-badge": {
              boxSizing: "border-box",
              border: "2px solid white",
              padding: 0,
              width: 20,
              height: 21,
              minWidth: 20,
              borderRadius: "50%",
              fontSize: "0.65rem",
              fontWeight: 600,
              top: 2,
              right: 2,
            },
          }}
        >
          <IconButton
            onClick={() => chatStore.setIsSidebarFilterModeEnabled(true)}
            size="small"
            sx={{
              width: 40,
              height: 40,
              borderRadius: "8px",
              border: "1px solid rgba(0, 0, 0, 0.12)",
              bgcolor: isSidebarFilterModeEnabled
                ? "rgba(0, 0, 0, 0.06)"
                : "white",
              color: "black",
              "&:hover": {
                bgcolor: "rgba(0, 0, 0, 0.06)",
              },
            }}
          >
            <PiSlidersHorizontalLight size={18} />
          </IconButton>
        </Badge>
      </Tooltip>
    </Box>
  );
});
